<template>

    <div class="form">
        <form>

            <AdditionalPersonalInfo ref="personalInfo" @change-state="updateState"/>

            <EmergencyContactsAndVaccinations ref="emergencyContact" @change-state="updateState"/>

            <ArtistAddressInformation ref="addressInfo" @change-state="updateState"/>

            <ArtistPassportInformation ref="passportInfo" @change-state="updateState"/>

            <h3 class="profile__ttl">Scanned Copies*</h3>
            <div class="passport mb-5">

                <PhotoDocumentContainer
                    :title="`Passport page with photo and information*`"
                    :file="passportInfo.passport_photo"
                    :field="`passport_photo`"
                    @update-photo="updateDocumentPhoto"
                />

                <PhotoDocumentContainer
                    :title="`Visa*`"
                    :file="passportInfo.visa_photo"
                    :field="`visa_photo`"
                    @update-photo="updateDocumentPhoto"
                />

                <PhotoDocumentContainer
                    :title="`Residency Card*`"
                    :file="passportInfo.residency_card_photo"
                    :field="`residency_card_photo`"
                    @update-photo="updateDocumentPhoto"
                />

            </div>


            <div class="row">
                <div class="col-6">
                    <div class="form-group m-0">
                        <button
                            class="btn btn_primary-outline pl-5 pr-5">
                            <span>Cancel</span>
                        </button>
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-group m-0 text-right">
                        <button
                            v-if="isPermission"
                            class="btn btn_golden"
                            @click.prevent="validate"
                        >
                            <span class="pl-5 pr-5">Save</span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    </div>

</template>

<script>
import EmergencyContactsAndVaccinations from "./EmergencyContactsAndVaccinations.vue";
import ArtistAddressInformation from "./ArtistAddressInformation.vue";
import ArtistPassportInformation from "./ArtistPassportInformation.vue";
import PhotoDocumentContainer from "../Common/PhotoDocumentContainer.vue";
import FileContainer from "../Common/FileContainer.vue";
import AdditionalPersonalInfo from "./AdditionalPersonalInfo.vue";
import ArtistBankInformation from "./ArtistBankInformation.vue";
import {validate} from "vee-validate";
import {mapActions, mapState} from "pinia";
import {useArtistStore} from "../../stores/ArtistStore";
import FormError from "../Common/FormError.vue";
import ArtistService from "../../services/ArtistService";

export default {
    name: 'ArtistPersonalInfoTab',
    components: {
        FormError,
        ArtistBankInformation,
        AdditionalPersonalInfo,
        FileContainer,
        PhotoDocumentContainer,
        ArtistPassportInformation, ArtistAddressInformation, EmergencyContactsAndVaccinations
    },
    data() {
        return {
            information: {}
        }
    },

    computed: {
        ...mapState(useArtistStore, {
            artist: 'artist',
            artistId: 'artistId',
            passportInfo: 'passportInfo'
        }),
        isPermission() {
            return this.adminType !== 'agent'
        },
    },
    props: {
        adminType: String
    },
    methods: {
        updateDocumentPhoto(field, file) {
            if (file ===  null) {
                this.passportInfo[field] = null
                this.information[`${field}_id`] = null
            } else {
                this.passportInfo[field] = file;
                this.information[`${field}_id`] = file.id
            }
        },

        async updateArtistPersonalInfo(info) {
            try {
                await ArtistService.updatePersonalArtistInfo(this.artistId, info) ;
                this.$showSuccessMessage('Profile was successfully updated')
            } catch (error) {
                this.$showErrorMessage('The profile has not been updated')
            }
        },
        validate() {
            (async () => {
                const list = [
                    {
                        error: 'Personal Information',
                        value: await this.$refs.personalInfo.$refs.form.validate()
                    },
                    {
                        error: 'Emergency contacts and vaccination',
                        value: await this.$refs.emergencyContact.$refs.form.validate()
                    },
                    {
                        error: 'Address Information',
                        value: await this.$refs.addressInfo.$refs.form.validate()
                    },
                    {
                        error: 'Passport Information',
                        value: await this.$refs.passportInfo.$refs.form.validate()
                    },
                ];
                const errors = [];
                const valid = list.every(form => !!form.value);

                list.forEach(form => {
                    if (!form.value) errors.push(form.error)
                })

                if (!valid) {
                    this.$showValidationErrorMessageAll(errors);
                } else {
                    await this.updateArtistPersonalInfo(this.information)
                }
            })();
        },
        updateState({ state }) {
            this.information = {...this.information,  ...state};
        },

    }
}


</script>

<style scoped>

</style>
